import { Stack, Typography } from "@mui/material";
import { StarsWithBgIcon } from "../images";

export const RecommendedReasonHeader = () => {
  return (
    <Stack flexDirection={"row"} gap={"8px"} alignItems={"center"}>
      <StarsWithBgIcon />
      <Typography variant={"button"} sx={{ color: "#232323" }}>
        Why this Account Fits
      </Typography>
    </Stack>
  );
};
